export default "__VITE_ASSET__DSJhZPa4__"